import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const GopuffIcon = ({
  width = '50',
  height = '50'
}: Omit<IconSvgProps, 'children'>) => {
  return (
    <IconSvg
      style={{
        width: width,
        height: height
      }}
      version="1.0"
      viewBox="10 0 270.1 178.1"
    >
      <path
        d="M189.3,69.9v21.3c0,5.5-1.7,8.8-5.9,8.8c-4.1,0-5.9-3.3-5.9-8.8V69.9h-11.7V92c0,11.5,7,16.3,17.6,16.3
	c8.7,0,17.6-4.8,17.6-16.3V69.9H189.3z"
        fill="#00A3FF"
      />
      <path
        d="M100.3,69.1c-12.1,0-20.1,7.8-20.1,19.9c0,12.1,8.5,19.3,19.4,19.3c10.1,0,19.8-6.3,19.8-20
	C119.5,77,111.8,69.1,100.3,69.1z M100,100c-5,0-7.7-4.9-7.7-11.3c0-5.6,2.1-11.3,7.7-11.3c5.3,0,7.4,5.7,7.4,11.2
	C107.4,95.5,104.5,100,100,100z"
        fill="#00A3FF"
      />
      <path
        d="M72,67.3C68,70,67,74.1,67,74.1c-2.1-2.7-6.5-4.8-11.7-4.8c-8.6,0-17.6,7.7-17.6,19.8c0,10.7,7.6,19,17.6,19
	c4.1,0,6.9-1,9.2-3.2c0,0,0,0.5,0,0.8c0,6.8-4.2,9.9-9.8,9.9c-5.4,0-9.2-1.8-11.6-3.2l-2.3,8.9c3.1,1.6,9.3,3.2,14.2,3.2
	c5.5,0,11.1-1.1,15.2-4.6c4.3-3.7,5.7-9.7,5.7-16.9V86.3c0.1-5.8,2.1-9.8,4.6-12.7L72,67.3z M57.5,100.1c-5,0-7.7-4.9-7.7-11.3
	c0-5.6,2.1-11.3,7.7-11.3c5.2,0,7.4,5.7,7.4,11.2C64.9,95.6,62,100.1,57.5,100.1z"
        fill="#00A3FF"
      />
      <path
        d="M142.7,69.1c-12.5,0-19.3,8.3-19.3,20.6v33.9H135V105c2.1,2.2,5.4,3.4,9.9,3.4c8.3,0,17.1-6.4,17.1-20.1
	C162,76.2,154,69.1,142.7,69.1z M142.6,100c-5,0-7.7-4.9-7.7-11.3c0-5.6,2.1-11.3,7.7-11.3c5.3,0,7.4,5.7,7.4,11.2
	C150,95.5,147.2,100,142.6,100z"
        fill="#00A3FF"
      />
      <path
        d="M255.7,61.9V53c-1.6-0.5-3.6-0.8-6.2-0.8c-3.4,0-7.5,1-10.4,3.7c-3.3,3.1-4.7,8.1-4.7,12.6v1.4h-12.1V68
	c-0.2-9.1,8.7-6.4,9.7-6.1v-8.9c-1.6-0.5-3.6-0.8-6.2-0.8c-3.4,0-7.5,1-10.4,3.7c-3.3,3.1-4.7,8.1-4.7,12.6v1.4h-5v8.6h5v29
	c0,8-5.5,6.8-8,6.4l-1.2,8.6c1.2,0.5,3.1,0.9,5,0.9c5.3,0,9-1.6,11.5-4c3.2-3.1,4.3-7.6,4.3-12l0.1-28.9h12v29
	c0.2,8.4-6.4,6.7-8,6.4l-1.2,8.6c1.2,0.5,3.1,0.9,5,0.9c5.3,0,9-1.6,11.5-4c3.2-3.1,4.3-7.6,4.3-12l0.1-28.9h9.6v-8.5H246V68
	C246.2,58.9,254.7,61.6,255.7,61.9z"
        fill="#00A3FF"
      />
    </IconSvg>
  )
}

export default GopuffIcon
